import type { StrategyEvaluator, SignalResult } from '../types';
import { ensureFlatOpts } from '../../analysis/trend-evaluator';
import { calculateMarketActivityTrend, cellDataKeys } from '../../analysis/trend-evaluator';

import { extractSnapshotOptions } from '../../../lib/snapshot-search';

export const evaluateMarketTrendActivity: StrategyEvaluator = (
    marketData,
    currentUnixTime,
    config,
    context
): SignalResult | null => {
    const { trendAnalysisData, chain } = context.liveIndicators;
    
    // We require the trendAnalysisData which contains historyWithITM
    if (!trendAnalysisData || !trendAnalysisData.data || trendAnalysisData.data.length < 2) return null;

    const historyWithITM = trendAnalysisData.data;
    
    const valKey = cellDataKeys[context.settingsMode] || 'volume';
    const overallTrend = calculateMarketActivityTrend(historyWithITM, context.activeRange, context.gap, valKey, 10);

    if (overallTrend === 'Neutral') return null;

    const spotPrice = trendAnalysisData.liveRow?.spotPrice || marketData.spotPrice;
    const atmStrike = Math.round(spotPrice / context.gap) * context.gap;
    
    const optionType = overallTrend === 'Bullish' ? 'CE' : 'PE';
    const entryStrike = atmStrike;
    
    const liveRow = trendAnalysisData.liveRow;
    const liveRawOptsArr = liveRow?.flatOpts || liveRow?.rawOpts || chain || extractSnapshotOptions(marketData, context.symbol || 'SENSEX', context.expiry || '') || [];
    const liveFlatOpts = ensureFlatOpts(liveRawOptsArr);
    const atmRow = liveFlatOpts.find((r: any) => r.strike === entryStrike && r.type === optionType);
    let entryPrice = 0;
    if (atmRow) {
        entryPrice = atmRow.ltp || atmRow.close || atmRow.price || 0;
    }

    if (entryPrice <= 0) return null;

    return {
        trade_type: overallTrend === 'Bullish' ? 'BULL' : 'BEAR',
        strike: entryStrike,
        option_type: optionType,
        entry_price: entryPrice,
        remarks: `Market Trend is ${overallTrend} based on Strike Activity. Entering ATM ${optionType}`
    };
};
